<script>
  /** @type {{ initial: string, theme?: string }} */
  let { initial, theme = 'clean' } = $props()

  const isBordered = $derived(['glass', 'aurora', 'ocean'].includes(theme))
  const isBrutal = $derived(theme === 'neubrutalism')
</script>

<div class="avatar" class:avatar-bordered={isBordered} class:avatar-brutal={isBrutal}>
  {initial}
</div>

<style>
  .avatar {
    width: 88px;
    height: 88px;
    border-radius: var(--avatar-radius);
    background: var(--avatar-bg);
    color: var(--avatar-text);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 16px;
    letter-spacing: -0.5px;
    box-shadow: 0 4px 16px color-mix(in srgb, var(--avatar-bg) 30%, transparent);
    border: 3px solid color-mix(in srgb, var(--page-bg) 100%, transparent);
    outline: 2px solid color-mix(in srgb, var(--avatar-bg) 15%, transparent);
  }

  .avatar-bordered {
    border: 2.5px solid var(--avatar-border);
    box-shadow: 0 0 0 4px rgba(255,255,255,0.1);
  }

  .avatar-brutal {
    border: 3px solid var(--text-primary);
    box-shadow: 4px 4px 0px var(--text-primary);
  }
</style>
